module.exports = __webpack_public_path__ + "static/media/folderindex-document-small.84118af5.svg";